import { useQuery } from "@tanstack/react-query";
import { fetchSettings } from "../services/settings";
import { LinktreeSettings } from "../types/Settings";
import { QUERY_CONSTANTS } from "../constants/query-constants";
import { useCookieConsent } from "../contexts/CookieConsentContext";

export const useSettings = () => {
    const { hasConsented } = useCookieConsent();

    return useQuery<LinktreeSettings>({
        queryKey: ["linktreeSettings", hasConsented],
        queryFn: fetchSettings,
        staleTime: QUERY_CONSTANTS.STALE_TIME,
        refetchInterval: QUERY_CONSTANTS.REFETCH_INTERVAL,
        enabled: hasConsented,
    });
};
